<vwui-root>
  @if (menuVisible) {
    <a11y-skip-link>{{ 'A11Y.go_to_content' | translate }}</a11y-skip-link>
  }
  @if (!menuVisible) {
    <a11y-skip-link [skipToElement]="'.skip-element'">{{ 'A11Y.go_to_content' | translate }}</a11y-skip-link>
  }

  @if (menuVisible) {
    <vwui-nav>
      <vwui-logo slot="logo" [logoSrc]="'/assets/images/logo.svg'"></vwui-logo>
      <app-menu type="projects"></app-menu>
      <app-menu type="admin"></app-menu>
      @if (userHasLogin) {
        <div slot="nav-footer">
          <div class="nav-logout-wrapper">
            <vwui-nav-item
              (click)="logout()"
              href="/logout"
              tabindex="-1"
              >
                <vwui-icon class="big" iconName="vwui-user"></vwui-icon>

                @if (info(); as info) {
                  <span class="user-info">{{ info.user.fullName || info.user.email || ('BUTTON.logout' | translate) }}</span>
                } @else {
                  <span>{{ 'BUTTON.logout' | translate }}</span>
                }
                <vwui-icon class="big" iconName="vwui-logout"></vwui-icon>
            </vwui-nav-item>
          </div>
          <div class="nav-version-wrapper">
            <app-version></app-version>
          </div>
        </div>
      }
    </vwui-nav>
  }
  <vwui-main>
    <router-outlet></router-outlet>
  </vwui-main>
</vwui-root>
